module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioSegundoQuiz.c9bcdd16.pdf";